import type { RuleId } from './ruleSchema';
import { RULE_PRESETS, type RulePreset } from './lotteryData';

/**
 * Fallback catalog when signed out (API order). Signed-in users replace presets
 * from `GET /v1/rules/catalog`.
 */
export const RULE_BUILDER_CATALOG_IDS: RuleId[] = [
  'birthday',
  'hot',
  'cold',
  'overdue',
  'odd-even',
  'spread',
];

export function getRuleBuilderCatalogPresets(): RulePreset[] {
  return RULE_BUILDER_CATALOG_IDS.map((id) => {
    const p = RULE_PRESETS.find((x) => x.id === id);
    if (!p) {
      throw new Error(`RULE_PRESETS missing entry for catalog id "${id}"`);
    }
    return p;
  });
}
